import { LoadState } from "../../constants/enums";
import { ISequenceDebugState } from "./SequenceDebug.types";

export const initialSequenceDebugState: ISequenceDebugState = {
  state: null,
  activeSequence: null,
  pendingJobs: [],
  loading: LoadState.NotLoaded,
};
